import { createAction, props } from '@ngrx/store';

import { type SendChatFeedbackRequest } from '@blaze-dashboard/ai-chat-domain';

export const sendFeedback = createAction(
  '[AI Chat][Feedback] Send feedback',
  props<{ feedback: SendChatFeedbackRequest; messageId: string }>(),
);

export const sendFeedbackSuccess = createAction(
  '[AI Chat][Feedback] Send feedback success',
  props<{ feedback: SendChatFeedbackRequest; messageId: string }>(),
);

export const sendFeedbackFailure = createAction(
  '[AI Chat][Feedback] Send feedback failure',
  props<{ feedback: SendChatFeedbackRequest; messageId: string; error: string }>(),
);
